<app-navbar></app-navbar>

<body>
<button id="succeeded_snack" class="snack_button" at-raised-button color="primary" (click)="snackbar_SucceededPost()">
  Snackbar CSS Styles</button>
<button id="failed_snack" class="snack_button" at-raised-button color="primary" (click)="snackbar_FailedPost()">
  Snackbar CSS Styles</button>
  <h1>
    <a class="black-box">
    <img src="assets/img/review_settings_white.svg" alt="search_icon" class="icon">
    Match Settings
    </a>
<!--    <a class="production">PRODUCTION</a>-->
    <a class="development">DEVELOPMENT</a>
  </h1>
  <table>
    <tr class="datatypes">
      <td>
        Data Type:
        <label>
          <input type="radio" name="datatype" value="Company" (change)="select_datatType($event)">
          <i>Company</i>
        </label>
        <label>
          <input type="radio" name="datatype" value="Person" (change)="select_datatType($event)">
          <i>Person</i>
        </label>
      </td>
    </tr>
  </table>

  <p></p>
  <p *ngIf="!is_Group_ready">Please select a datatype!</p>

  <table *ngIf="is_Group_ready" cellspacing="0" cellpadding="0" class="advanced_search">
    <tr>
      <td class="checklist">
        <p *ngFor="let field of settings_fields">
            <label  *ngIf="!hiddenSettingsFields.includes(field.FieldName)" for="checkbox-{{field.FieldName}}">
            <input type="checkbox" id="checkbox-{{field.FieldName}}" name="{{field.FieldName}}" value="{{field.FieldName}}"
                   (change)="checked_values($event)">
            {{field.FieldName}}
            </label><br *ngIf="!hiddenSettingsFields.includes(field.FieldName)" >
        </p>
      </td>
      <td *ngIf="is_Group_ready">
        <table class="in-table">
          <tr>
            <th>Group</th>
            <th>Exact <br> match</th>
            <th>Fuzzy <br> level</th>
            <th>Ignore <br> Null values</th>
            <th>Knowledge <br> base Library</th>
            <th>Group <br>Level</th>
            <th>Weight<br> in group</th>
          </tr>
          <tr *ngFor="let group of match_group">
            <td colspan="7">
              <table *ngFor="let groups of group.Groups" class="in-table">
                <tr class="list-header">
                  <td class="group">
                    <label for="selecetd_group-{{groups.GroupId}}" style="display: block;">
                      <input type="radio" id="selecetd_group-{{groups.GroupId}}" name="selecetd_group" value="{{groups.GroupId}}" (change)="Select_group($event)">
                      Setting {{groups.GroupId}}
                      <img src="assets/img/remove_field.svg" class="remove-group" (click)="RemoveGroup(groups.GroupId)">
                    </label>
                  </td>
                </tr>
                <tr class="select_row" *ngFor="let condition of groups.Conditions">
                  <td>
                    <table *ngFor="let fields of condition.Fields" class="in-table">
                      <tr>
                        <td class="alt">
                          {{fields.ColumnName}}
                        </td>
                        <td class="alt">
                          <label for="checked-{{fields.ColumnName}}">
                            <input id="checked-{{fields.ColumnName}}" type="checkbox"
                                   (click)="construct_ExactMatch(fields.ColumnName, groups.GroupId)" class="input-checkbox">
                          </label>
                        </td>
                        <td class="alt">
                          <label for="Level-{{fields.ColumnName}}">
                            <input id="Level-{{fields.ColumnName}}" (change)="construct_Fuzzy($event, fields.ColumnName, groups.GroupId)" class="input-number" [value]="condition.Level*100">
                          </label>
                        </td>
                        <td class="alt">
                          <label for="IgnoreNullValues-{{fields.ColumnName}}">
                            {{condition.IgnoreNullValues}}
                            <select id="IgnoreNullValues-{{fields.ColumnName}}" class="dropdown" value="{{condition.IgnoreNullValues}}" (change)="nullVal($event, fields.ColumnName, groups.GroupId)">
                              <option>true</option>
                              <option>false</option>
                            </select>
                          </label>
                        </td>
                        <td class="alt">
                          <label for="DictionaryType-{{fields.ColumnName}}">
                            {{condition.DictionaryType}}
                            <select id="DictionaryType-{{fields.ColumnName}}" class="dropdown" value="{{condition.DictionaryType}}" (change)="construct_DictionaryType($event, fields.ColumnName, groups.GroupId)">
                              <option *ngFor="let dict of dictionary" [defaultSelected]="">{{dict}}</option>
                            </select>
                          </label>
                        </td>
                        <td class="alt">
                          <label>
                            <input (change)="construct_GroupLevel($event, groups.GroupId)" [value]="groups.GroupLevel*100" class="input-number">
                          </label>
                        </td>
                        <td class="alt">
                          <label for="Weight-{{fields.ColumnName}}">
                            <input id="Weight-{{fields.ColumnName}}" (change)="construct_WeightInGroup($event, fields.ColumnName, groups.GroupId)" class="input-number" [value]="condition.Weight*100">
                          </label>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

            </td>
          </tr>
          <tr *ngIf="is_dataType_selected" (click)="AddGroup()">
            <td colspan="7" class="addGroup_button" *ngIf="is_Group_ready">
              <a>+ Add Setting</a>
            </td>
          </tr>
          <tr *ngIf="is_dataType_selected">
            <td colspan="7" *ngIf="is_Group_ready">
              <button class="simple-button" (click)="Send()">Save</button>
            </td>
          </tr>
          <tr *ngIf="is_Engagement">
            <td colspan="7">
              No available data at the moment!
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
